/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agtron_InternalInputs */

const en_agtron_internal = /** @type {(inputs: Agtron_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agtron Internal`)
};

const es_agtron_internal = /** @type {(inputs: Agtron_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agtron interno`)
};

/**
* | output |
* | --- |
* | "Agtron Internal" |
*
* @param {Agtron_InternalInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const agtron_internal = /** @type {((inputs?: Agtron_InternalInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agtron_InternalInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agtron_internal(inputs)
	return es_agtron_internal(inputs)
});